import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../lib/api";
import type { DiscrepancyView, EventView, ObservationView } from "@shared/types";
import { StatusPill } from "../components/Status";

export function EventRecord() {
  const { slug } = useParams();
  const [view, setView] = useState<{ event: EventView; observations: ObservationView[]; discrepancies: DiscrepancyView[] } | null>(null);
  useEffect(() => {
    if (!slug) return;
    api<{ event: EventView; observations: ObservationView[]; discrepancies: DiscrepancyView[] }>(`/api/events/${slug}`)
      .then(setView)
      .catch(() => setView(null));
  }, [slug]);
  if (!view) return <section className="page-hero"><div className="wrap"><p className="muted">Loading event…</p></div></section>;
  const e = view.event;
  return (
    <section className="page-hero">
      <div className="wrap">
        <p className="kicker">Observed event</p>
        <h1>{e.name}</h1>
        <div className="record-meta">
          <span>{e.startedAt}</span>
          <Link to={`/system/${e.systemSlug}`}>{e.systemSlug}</Link>
          <StatusPill status={e.epistemic} />
        </div>
        <p className="summary">{e.summary}</p>
        <h2>Observations</h2>
        {view.observations.map((o) => (
          <article className="ev-item" key={o.id}>
            <StatusPill status={o.epistemic} />
            <p>
              {o.variable}: {o.value} {o.unit} · {o.locationName} · {o.method}
            </p>
          </article>
        ))}
        <h2>Predicted → observed</h2>
        {view.discrepancies.length === 0 && <p className="muted">No extracted residual is stored for this event. We do not invent one.</p>}
        {view.discrepancies.map((d) => (
          <article className="card" key={d.id}>
            <StatusPill status={d.epistemic} />
            <p>Model predicted {d.predicted} {d.unit}.</p>
            <p>Observed: {d.observed} {d.unit}.</p>
            <p>Difference: {d.difference}.</p>
            <p>{d.explanation}</p>
            <p className="muted small">{d.reviewStatus}. Do not automatically correct a model from one discrepancy.</p>
          </article>
        ))}
      </div>
    </section>
  );
}
